import {
	Component,
	Inject,
	OnInit,
	ViewChild,
	ChangeDetectorRef,
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { Subject } from "rxjs";
import { debounceTime, map } from "rxjs/operators";
import { AppProductDetailsComponent } from "../../product/app-product-details/app-product-details.component";

@Component({
	selector: "meu-app-order-detail-add-product",
	templateUrl: "./app-order-detail-add-product.component.html",
	styleUrls: ["./app-order-detail-add-product.component.scss"],
})
export class AppOrderDetailAddProductComponent implements OnInit {
	constructor(
		@Inject(MAT_DIALOG_DATA) public data,
		public dialogRef: MatDialogRef<AppOrderDetailAddProductComponent>,
		private changeDetectorRef: ChangeDetectorRef
	) {}
	addressID: any = "";
	addressOutput: any = null;
	isEditingAddress: boolean = false;
	searchStr: any;
	productIdSelected;
	private searchStr$ = new Subject();

	@ViewChild(AppProductDetailsComponent, { static: false })
	productDetailsComponent;
	ngOnInit() {
		this.searchStr$.pipe(debounceTime(400)).subscribe((value) => {
			this.searchStr = value;
		});
	}

	onKeyUp(value) {
		this.searchStr$.next(value);
	}
	addProductToOrder() {
		if (this.data.orderId) {
			this.productDetailsComponent.addProductToOrder(this.data.orderId);
		} else {
			this.productDetailsComponent.addCartProduct(false);
		}
	}
	backToSearch() {
		this.productIdSelected = "";
		// this.searchStr = this.strClone;
		// this.searchStr$.next(this.searchStr);
		this.changeDetectorRef.markForCheck();
	}
	closeDialog(event) {
		this.dialogRef.close({ isAddProduct: event });
	}
}
